import { Component, Input, Output, EventEmitter, OnChanges, OnInit, ChangeDetectionStrategy, SimpleChange } from '@angular/core';
import { Router } from '@angular/router';

import { FlattenedProjectTask, RequestDayEdit } from '../app.interfaces';

import * as moment from 'moment';

@Component({
  selector: 'mcrit-time-table-week-body',
  templateUrl: './week-time-table-body.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush, //indica que ha de mirar les actualitzacions si canvien inputs del component. Elimina molts components de l'arbre.
  styleUrls: ['./week-time-table-body.component.scss']
})
export class WeekTimeTableBodyComponent implements OnChanges, OnInit {
  @Input() firstDayWeek;
  @Input() tipus: string;
  @Input() projectAggregates;

  @Output() requestDayEdit: EventEmitter<RequestDayEdit> = new EventEmitter();

  public weekDays: Array<{weekDay: string; date: string}>;
  public weekDaysAcum;

  private setDisplayDates() {
    this.weekDays = (new Array(7).fill(0)).map((item, index) => {
      return {
        weekDay: moment(this.firstDayWeek).locale('ca').add(index, 'day').format('dd'),
        date: moment(this.firstDayWeek).locale('ca').add(index, 'day').format('MMM D')
      };
    });
  }

  public getFormatedDay(offSet: number): string {
    return moment(this.firstDayWeek).locale('ca').add(offSet, 'days').format('ll');
  }

  public editDay(project: FlattenedProjectTask, i: number): void {
    this.requestDayEdit.emit({
      id: project.id,
      date: moment(this.firstDayWeek).locale('ca').add(i, 'day').toISOString().slice(0, 10)
    });
  }

  public sumWeekHours(project: FlattenedProjectTask, i: number): number {
    return project.dailyHours.reduce((acum: number, value: number): number => {
      return acum + value;
    }, 0);
  }

  public weekDaysAcumular(i){
    return this.weekDaysAcum[i];
  }

  constructor(private router: Router) {this.weekDaysAcum = (new Array(7)).fill(0);}

  ngOnInit() {this.setDisplayDates();}

  ngOnChanges(changes: {[propertyName: string]: SimpleChange}) {
    /*this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['/projects/hours']);*/
    if (changes['firstDayWeek'])this.setDisplayDates();
    if (changes['projectAggregates']){
      this.weekDaysAcum = this.projectAggregates.reduce((acum, curr) => {
        curr.dailyHours.forEach((value, index) => {
          acum[index] +=  value;
        });
        return acum;
      }, (new Array(7)).fill(0));
    }
  }

  public goProject(codi){ if(this.tipus == 'treball')this.router.navigate(['project',codi]);else this.router.navigate(['proposal',codi]);};

}
